import React, { Component } from 'react';

import HeaderContainer from '../HeaderContainer/HeaderContainer';
import ContentContainer from '../ContentContainer/ContentContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import FooterContainerTablet from '../FooterContainer/FooterContainerTablet';
import SharedApp from '../../Shared/SharedApp/SharedApp';
import { Helmet } from 'react-helmet';
import { HeaderError } from '../../../Error/Desktop/HeaderError';
import { ContentError } from '../../../Error/Shared/ContentError';
import { FooterError } from '../../../Error/Desktop/FooterError';

import '../../../../styles/desktop/main.scss';

import loadable from '@loadable/component';
import { AppContextProvider } from '../../../../contexts/AppContext';
import { FeedbackProvider } from '../../../Feedback/FeedbackContext';
import { StoreProvider } from '../../../../contexts/StoreContext';

const ProductDetail = loadable(
  () =>
    import(/* webpackChunkName: "desktopProductDetail" */ '../../../Views/Desktop/Content/ProductDetail/ProductDetail'),
  { ssr: true }
);
const ProductDisplayEcard = loadable(
  () =>
    import(
      /* webpackChunkName: "desktopProductDisplayEcard" */ '../../../Views/Desktop/Content/ProductDetail/ProductDisplayEcard/ProductDisplayEcard'
    ),
  { ssr: true }
);
const Layouts = loadable(
  () => import(/* webpackChunkName: "desktopLayouts" */ '../../../Views/Desktop/Content/Layouts/Layouts'),
  { ssr: true }
);

// const HeaderContainer = loadable(() => import(/* webpackChunkName: "desktopHeader" */ '../HeaderContainer/HeaderContainer'));
// const FooterContainer = loadable(() => import(/* webpackChunkName: "desktopFooter" */ '../FooterContainer/FooterContainer'));

const StoreDetail = loadable(
  () => import(/* webpackChunkName: "desktopStoreDetail" */ '../../../Views/Desktop/Content/StoreDetail/StoreDetail'),
  { ssr: true }
);
const StoreHome = loadable(
  () => import(/* webpackChunkName: "desktopStoreHome" */ '../../../Views/Desktop/Content/StoreHome/StoreHome'),
  { ssr: true }
);
const StoreAll = loadable(
  () => import(/* webpackChunkName: "desktopStoreHome" */ '../../../Views/Desktop/Content/StoreHome/StoreAll'),
  { ssr: true }
);
// const ChangeCountry = loadable(() => import(/* webpackChunkName: "desktopChangeCountry" */ '../../../Views/Shared/Content/ChangeCountry/ChangeCountry'), {ssr: true});
const ContactUs = loadable(
  () => import(/* webpackChunkName: "desktopContactUs" */ '../../../Views/Shared/Content/ContactUs/ContactUs'),
  { ssr: true }
);
const ContactUsInternational = loadable(
  () =>
    import(/* webpackChunkName: "desktopContactUs" */ '../../../Views/Shared/Content/ContactUs/ContactUsInternational'),
  { ssr: true }
);
const StorePurchaseReturns = loadable(
  () =>
    import(
      /* webpackChunkName: "desktopStorePurchaseReturns" */ '../../../Views/Shared/Content/StorePurchaseReturns/StorePurchaseReturns'
    ),
  { ssr: true }
);
const Events = loadable(
  () => import(/* webpackChunkName: "desktopEvents" */ '../../../Views/Shared/Content/Events/Events'),
  { ssr: true }
);
const Subscriptions = loadable(
  () => import(/* webpackChunkName: "desktopSubscriptions" */ '../../../Views/Shared/Content/Member/Subscriptions'),
  { ssr: true }
);
const Feedback = loadable(
  () => import(/* webpackChunkName: "desktopFeedback" */ '../../../Views/Shared/Content/Feedback/Feedback'),
  { ssr: true }
);
const MyPreferences = loadable(
  () =>
    import(/* webpackChunkName: "desktopMyPreferences" */ '../../../Views/Shared/Content/MyPreferences/MyPreferences'),
  { ssr: true }
);
const Appointments = loadable(
  () => import(/* webpackChunkName: "myAppointmentsPage" */ '../../../MyAppointments/MyAppointmentsPage'),
  { ssr: true }
);
const ManageDillardsCard = loadable(
  () =>
    import(
      /* webpackChunkName: "desktopManageDillardsCard" */ '../../../Views/Shared/Content/Member/ManageDillardsCard/ManageDillardsCard'
    ),
  { ssr: true }
);
const PhoneOrderCheckout = loadable(
  () =>
    import(
      /* webpackChunkName: "desktopPhoneOrderCheckout" */ '../../../Views/Shared/Content/PhoneOrderCheckout/PhoneOrderCheckout'
    ),
  { ssr: true }
);

export class DesktopApp extends SharedApp {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      notAvailableTitle:
        this.state.contentData.productLayout == 'NotAvailable' &&
        this.state.navState !== undefined &&
        this.state.navState.split('/').length > 1
          ? this.state.navState
              .split('/')[2]
              .split('-')
              .join(' ')
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
              .concat(" | Dillard's")
          : '',
    };
  }

  passedAppFunctionsWithChunks() {
    var superPassedAppFunctions = super.passedAppFunctions();
    superPassedAppFunctions.chunks = {
      Layouts: Layouts,
      ProductDetail: ProductDetail,
      ProductDisplayEcard: ProductDisplayEcard,
      StoreDetail: StoreDetail,
      StoreHome: StoreHome,
      StoreAll: StoreAll,
      ContactUs: ContactUs,
      ContactUsInternational: ContactUsInternational,
      StorePurchaseReturns: StorePurchaseReturns,
      Events: Events,
      Subscriptions: Subscriptions,
      Feedback: Feedback,
      MyPreferences: MyPreferences,
      Appointments: Appointments,
      ManageDillardsCard: ManageDillardsCard,
      PhoneOrderCheckout: PhoneOrderCheckout,
    };
    return superPassedAppFunctions;
  }

  render() {
    return (
      <StoreProvider>
        <AppContextProvider
          value={{
            state: this.state,
            passedAppFunctions: this.passedAppFunctions(),
          }}
        >
          <FeedbackProvider>
            <div id='app_wrapper' className={`${this.props.initialState.siteFormat}Page`}>
              {this.state.contentData.productLayout == 'NotAvailable' ? (
                <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
              ) : (
                ''
              )}
              {this.state.contentData.productLayout == 'NotAvailable' ? (
                <Helmet
                  meta={[{ charset: 'utf-8' }]}
                  title={this.state.notAvailableTitle}
                  link={[
                    {
                      rel: 'canonical',
                      href: 'https://' + this.state.headerFooterData.JSON.wasParms.domainName + this.state.navState,
                    },
                  ]}
                />
              ) : (
                <Helmet
                  meta={[{ charset: 'utf-8' }]}
                  title='Dillards.com'
                  link={[
                    {
                      rel: 'canonical',
                      href: 'https://' + this.state.headerFooterData.JSON.wasParms.domainName + this.state.navState,
                    },
                  ]}
                />
              )}

              {/* <Helmet>
                <meta charSet="utf-8" />
                <title>Dillards.com</title>
                <link rel="canonical" href="https://www.dillards.com" />
              </Helmet> */}
              {this.state.country != 'US' ? (
                <style type='text/css'>{`
                    .hide-when-international {
                      display:none!important;
                    }
                    .show-when-international {
                      display:block;
                    }
                  `}</style>
              ) : (
                <style type='text/css'>{`
                    .show-when-international {
                      display:none!important;
                    }
                  `}</style>
              )}
              <HeaderError passedAppFunctions={this.passedAppFunctions()} contentData={this.state.contentData}>
                <HeaderContainer
                  headerData={this.state.headerFooterData}
                  myDillardsInfo={this.state.myDillardsInfo}
                  passedAppFunctions={this.passedAppFunctions()}
                  siteFormat={this.props.initialState.siteFormat}
                />
              </HeaderError>
              <ContentError
                passedAppFunctions={this.passedAppFunctions()}
                contentData={this.state.contentData}
                quickViewData={this.state.quickViewData}
              >
                <ContentContainer
                  headerData={this.state.headerFooterData}
                  contentData={this.state.contentData}
                  quickViewData={this.state.quickViewData}
                  passedAppFunctions={this.passedAppFunctionsWithChunks()}
                  feedbackModalOpen={this.state.feedbackModalOpen}
                  isStoreFeedback={this.state.isStoreFeedback}
                  popUpSurveyOpen={this.state.triggerGeneralFeedbackModal}
                  handleGeneralFeedback={this.handleGeneralFeedback}
                />
              </ContentError>
              <FooterError passedAppFunctions={this.passedAppFunctions()} contentData={this.state.contentData}>
                {this.state.siteFormat == 'tablet' ? (
                  <FooterContainerTablet
                    footerData={this.state.headerFooterData}
                    passedAppFunctions={this.passedAppFunctions()}
                  />
                ) : (
                  <FooterContainer
                    footerData={this.state.headerFooterData}
                    passedAppFunctions={this.passedAppFunctions()}
                  />
                )}
              </FooterError>
            </div>
          </FeedbackProvider>
        </AppContextProvider>
      </StoreProvider>
    );
  }
  componentDidMount() {
    if (/Edge/.test(navigator.userAgent)) $('html').addClass('microsoft-edge');
    else if (navigator.userAgent.indexOf('Firefox') > -1) $('html').addClass('firefox');
    this.bindPreloadRequiredChunk(
      ['/p/:name/:productId', '/p/:name/:productId/outfit', '/p/:name/:productId/sale'].sort().join('|'),
      ProductDetail
    );
    this.bindPreloadRequiredChunk(
      [
        '/brand/sale-clearance/:manufacturer/:categoryName/:pathModifier',
        '/brand/sale-clearance/:manufacturer/:categoryName',
        '/brand/sale-clearance/:manufacturer',
        '/brand/:manufacturer',
        '/brand/:manufacturer/:categoryName',
        '/brand/:manufacturer/:categoryName/:pathModifier',
        '/c/:pathToken',
        '/c/:pathToken/:pathModifier',
        '/c/:pathToken/:pathModifier/:color',
        '/c/:pathPrefix/:pathToken/:pathModifier/:color',
        '/search-term/:searchTerm',
        '/search-term/:searchTerm/:categoryName',
        '/search-term/:searchTerm/:categoryName/:pathModifier',
        '/search-term/:pathToken/:searchTerm/:categoryName/:pathModifier',
        '/chanel/c/:pathToken',
        '/',
      ]
        .sort()
        .join('|'),
      Layouts
    );
    this.bindPreloadRequiredChunk('ecard', ProductDisplayEcard);
    this.bindPreloadRequiredChunk('/contactus', ContactUs);
    this.bindPreloadRequiredChunk('/my-preferences', MyPreferences);
    this.bindPreloadRequiredChunk('/internationalhelp', ContactUsInternational);
    this.bindPreloadRequiredChunk('/returns', StorePurchaseReturns);
    this.bindPreloadRequiredChunk('/events/:eventId', Events);
    this.bindPreloadRequiredChunk('/store-purchase-returns', StorePurchaseReturns);
    this.bindPreloadRequiredChunk('/member/subscriptions', Subscriptions);
    this.bindPreloadRequiredChunk('/feedback/:templateId', Feedback);
    this.bindPreloadRequiredChunk('/stores/:name/:storeNum', StoreDetail);
    this.bindPreloadRequiredChunk(['/stores', '/stores/:stateName'].sort().join('|'), StoreHome);
    this.bindPreloadRequiredChunk('/member/manage-dillards-card', ManageDillardsCard);
    this.bindPreloadRequiredChunk('/checkout/phone-orders/:orderID', PhoneOrderCheckout);
    this.bindPreloadRequiredChunk(['/stores/all'].sort().join('|'), StoreAll);

    //new work
    super.componentDidMount();
  }
}

export default DesktopApp;
